<template>
  <div v-if="showCartouche" class="a-search-cartouches">
    <!--aria heading -->
    <component :is="headingTag" :id="cartouchesId" class="visually-hidden">
      {{ ariaHeading }}
    </component>
    <ul class="a-search-cartouches__list" :aria-labelledby="cartouchesId">
      <!-- <li
        v-if="hasMultipleImages"
        ref="multiImages"
        class="a-cartouches__has-images"
      >
        {{ multiImageText }}
      </li> -->
      <li
        v-if="item.manuscript_number && showManuscriptNumber"
        ref="manuscript"
        class="a-search-cartouches__part"
      >
        {{ item.manuscript_number }}
      </li>
      <li v-if="hasParts" ref="hasParts" class="a-search-cartouches__part">
        {{ hasPartsText }}
      </li>
      <li
        v-if="item.parent_tree && showParentTree"
        ref="partOf"
        class="a-search-cartouches__part"
      >
        {{ partOfText }}
      </li>
      <DeaccessionedTag v-if="item.is_deaccessioned" />
    </ul>
  </div>
</template>

<script>
import { useLocalization } from "@thegetty-private/getty-ui";
import { useId } from "vue";
import DeaccessionedTag from "@/components/atoms/deaccessionedTag/index.vue";

export default {
  name: "SearchCartouches",
  components: {
    DeaccessionedTag
  },

  props: {
    /**
     * The Heading Level to display
     */
    headingLevel: {
      type: Number,
      default: 5
    },
    /**
     * The Search Item Object
     */
    item: {
      type: Object,
      required: true
    },
    /**
     * whether to show the manuscript number
     */
    showManuscriptNumber: {
      type: Boolean,
      default: false
    },
    /**
     * Whether to show the parent tree
     */
    showParentTree: {
      type: Boolean,
      default: true
    }
  },
  setup(props) {
    return {
      ...useLocalization({
        baseLocaleKey: props?.baseLocaleKey
      })
    };
  },

  data() {
    return {
      /**
       * The translated Aria heading for the list of indicators
       */
      ariaHeading: this.translatePart(`image_and_caption.cartouches_list_aria`),
      /**
       * Translated text to display if an item has parts
       */
      hasPartsText: this.translatePart(`image_and_caption.has_parts`),
      /**
       * Translated text to display if an item has multiple images
       */
      multiImageText: this.translatePart(`image_and_caption.has_multi_images`)
    };
  },
  computed: {
    /**
     * The Cartouches ID for the aria-labelledby
     */
    cartouchesId() {
      return "cartouches_" + useId();
    },
    /**
     * whether the item has multiple views or not
     *
     * @returns {boolean}
     */
    hasMultipleImages() {
      if (this.item.manifest && this.item.manifest.numItems > 1) {
        return true;
      }
      return false;
    },
    /**
     * Whehter the item has multiple parts or not
     *
     * @returns boolean
     */
    hasParts() {
      return this.item.is_parent;
    },
    /**
     * The Heading Tag for the Heading component
     */
    headingTag() {
      return "h" + this.headingLevel;
    },
    /**
     * Translated text to display if an item is part of a complex object
     */
    partOfText() {
      if (!this.item.parent_tree) {
        return undefined;
      }

      const parent = this.item.parent_tree[this.item.parent_tree.length - 1];

      return this.translatePart(`image_and_caption.part_of`, {
        parent: parent.primary_name
      });
    },
    /**
     * Whether or not to render the cartouche for the current item
     */
    showCartouche() {
      return (
        this.showManuscriptNumber ||
        this.hasParts ||
        this.showParentTree ||
        this.item.is_deaccessioned
      );
    }
  }
};
</script>

<style lang="scss">
@import "./index.scss";
</style>
